import MainStore from "../store/MainStore";


class ProductsServices {

    async getFormsPRoducts(userType) {


        let result = await axios.post('/Api/shop/products', {type: 'form', 'entity':userType});
        if (result?.data?.data) {
            return {
                sections: [
                    {
                        title: "Urbanisme Réglementaire",
                        order: 0,
                        forms: result.data.data.filter(item => item?.active && item?.metadata?.prod_statut === "on")
                            .sort((a,b)=>{
                                if (a?.name < b?.name) {
                                    return -1;
                                }
                                if (a?.name > b?.name) {
                                    return 1;
                                }
                                // names must be equal
                                return 0;
                            })
                    },
                ]
            }
        } else {
            if (userType === "collective") {
                return {
                    sections: [
                        {
                            title: "Urbanisme Réglementaire",
                            order: 0,
                            forms: [
                                {
                                    'label': 'Renseignement d\'Urbanisme ',
                                    'code': 'ru',
                                    'amount': null,
                                    "info": "linkInfo",
                                    "order": 0,
                                    "activ": true,
                                    "styles": "",
                                    "access": "renseign_urba"
                                },
                                {
                                    'label': 'Certificat d\'Urbanisme ',
                                    'code': 'cua',
                                    'amount': null,
                                    "info": "linkInfo",
                                    "order": 0,
                                    "activ": true,
                                    "styles": "",
                                    "access": "certif_urba"
                                },
                                {
                                    'label': 'Certificat d\'Urbanisme ',
                                    'code': 'cub',
                                    'amount': null,
                                    "info": "linkInfo",
                                    "order": 0,
                                    "activ": true,
                                    "styles": "",
                                    "access": "certif_urba"
                                },
                            ]
                        },
                    ]
                }
            } else {
                return (
                    {
                        sections: [
                            {
                                title: "Urbanisme Réglementaire",
                                order: 0,
                                forms: [
                                    {
                                        'label': 'Note de renseignement d\'Urbanisme ',
                                        'code': 'nru',
                                        'amount': 100.0,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },
                                    {
                                        'label': 'Note de renseignement d\'Urbanisme - professionnels  ',
                                        'code': 'nrupro',
                                        'amount': 120.0,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },
                                    {
                                        'label': 'Note de renseignement d\'Urbanisme - Experts ',
                                        'code': 'nruexp',
                                        'amount': 150.0,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },
                                    {
                                        'label': 'État des Risques et Pollution',
                                        'code': 'erp',
                                        'amount': 15.0,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },
                                    {
                                        'label': 'Droit de préemption',
                                        'code': 'dpu',
                                        'amount': 30.0,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },
                                    {
                                        'label': 'Plan d\'aménagement et de développement durable de la Corse ',
                                        'code': 'pad',
                                        'amount': 35.0,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },
                                    {
                                        'label': 'Étude d\'urbanisme et de faisabilité ',
                                        'code': 'euf',
                                        'amount': 26.0,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },
                                    {
                                        'label': 'Certificat d\'Urbanisme d\'information ',
                                        'code': 'cua',
                                        'amount': 30,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },
                                    {
                                        'label': 'Certificat d\'Urbanisme opérationnel',
                                        'code': 'cub',
                                        'amount': 468,
                                        "info": "linkInfo",
                                        "order": 0,
                                        "activ": true,
                                        "styles": ""
                                    },

                                ]
                            }
                        ]
                    })
            }
        }
    }
}

export default ProductsServices;
